const { scores, weights } = require('../config')
const html = require('nanohtml')
const _ = require('morphable')

module.exports = _(function (course, state) {
  return html`<tr>
    <td class="course-name"><input onkeyup=${e => e.keyCode === 13 ? ( state.courses.map(crs => crs.id).indexOf(course.id) == state.courses.length-1 ? state.newCourse() : e.target.blur() ) : ``} onchange=${e => course.name = e.target.value} type="text" placeholder="Course name" value=${course.name}></td>
    <td class="course-grade"><select onchange=${e => course.grade = e.target.value}>
      <option disabled selected value=${``}>Grade</option>
      ${Object.keys(scores).map(grade => grade !== '' ? html`
        <option value="${grade}" ${course.grade == grade ? `selected` : ``}>${grade}</option>
      ` : ``)}
    </select></td>
    <td class="course-credits"><input onchange=${e => course.credits = e.target.value} type="text" value=${course.credits}></td>
    <td class="course-weight"><select onchange=${e => course.weight = e.target.value}>
      ${Object.keys(weights).map(weight => html`
        <option value="${weight}" ${course.weight == weight ? `selected` : ``}>${weight}</option>
      `)}
    </select></td>
    <td><button class="pure-button" onclick=${course.remove}>x</button></td>
  </tr>`
})
